<script setup lang="ts">
import GenerateButton from "@/components/AccountParts/GenerateButton.vue"
import { generateEmail } from "@/services/functions"
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue', 'displayError'])
const props = defineProps<{
  buttonName?: string
  driverId: string
  officeId: number | null
  class?: string
}>()

const mailGenerationErrorMessage: string[] = [i18n.global.t('pages.accounts.messages.mailGenerationError')]

function makeEmail() {
  if (!props.driverId || !props.officeId) return emits('displayError', mailGenerationErrorMessage)
  const email = generateEmail(props.driverId, props.officeId)
  emits("update:modelValue",  email)
  emits('displayError', [])
}
</script>
<template>
  <div :class="props.class">
    <GenerateButton
      :buttonName="props.buttonName"
      @generate="makeEmail"
    />
  </div>
</template>